/**
 * Logger condicional que só exibe logs em desenvolvimento
 * Evita poluir o console em produção
 */
const logger = {
  /**
   * Exibe warning apenas em desenvolvimento
   * @param {string} message - Mensagem de warning
   * @param {...any} args - Argumentos adicionais
   */
  warn: (message, ...args) => {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(message, ...args)
    }
  },

  /**
   * Exibe erro apenas em desenvolvimento
   * @param {string} message - Mensagem de erro
   * @param {...any} args - Argumentos adicionais
   */
  error: (message, ...args) => {
    if (process.env.NODE_ENV !== 'production') {
      console.error(message, ...args)
    }
  },

  /**
   * Exibe info apenas em desenvolvimento
   * @param {string} message - Mensagem informativa
   * @param {...any} args - Argumentos adicionais
   */
  info: (message, ...args) => {
    if (process.env.NODE_ENV !== 'production') {
      console.info(message, ...args)
    }
  },

  /**
   * Exibe log apenas em desenvolvimento
   * @param {string} message - Mensagem de log
   * @param {...any} args - Argumentos adicionais
   */
  log: (message, ...args) => {
    if (process.env.NODE_ENV !== 'production') {
      console.log(message, ...args)
    }
  }
}

export default logger
